import { render, staticRenderFns } from "./contact.html?vue&type=template&id=3556ba5c&scoped=true&"
import script from "./contact.js?vue&type=script&lang=js&"
export * from "./contact.js?vue&type=script&lang=js&"
import style0 from "./contact.scss?vue&type=style&index=0&id=3556ba5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3556ba5c",
  null
  
)

export default component.exports